import { MdMsgBox } from 'mdesign-plus';

export const useSuccessMsgBox = (message, callback) => {
    MdMsgBox({
        message,
        type: 'success',
        iconClass: 'md-icon-circle-check',
        title: '',
        // customClass: 'md-messagebox confirm',
        confirmButtonText: 'OK',
        showClose: true,
        center: true,
        closeOnClickModal: false,
        lockScroll: false,
        callback
    });
}

// 挂载到 window 对象
if (typeof window !== 'undefined') {
    window.useSuccessMsgBox = useSuccessMsgBox;
}